import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardHeader,
  Collapse
} from "reactstrap";
import classnames from "classnames";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useProfile } from "../../../Components/Hooks/UserHooks";
import { getPhaseById as onGetPhaseDetails } from "../../../slices/thunks";
import moment from "moment";

const PhaseDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [phase, setPhase] = useState(null);
  const [col1, setcol1] = useState(true);
  const [col2, setcol2] = useState(true);
  const [col3, setcol3] = useState(true);

  useEffect(() => {
    if (id) {
      dispatch(onGetPhaseDetails(id))
        .unwrap()
        .then((data) => {
          setPhase(data);
        })
        .catch((error) => {
          console.error("Failed to fetch phase details:", error);
        });
    }
  }, [id, dispatch]);

  const formatDate = (date) => {
    return moment(date).format("DD MMM YYYY");
  };

  function togglecol1() {
    setcol1(!col1);
  }

  return (
    <div className="page-content">
      <Container fluid>
        {/* <BreadCrumb title="Phase Details" pageTitle="Phases" /> */}

        <Row>
          <Col >
            <Card>
              <CardHeader>
                <div className="d-flex align-items-center">
                  <h5 className="card-title flex-grow-1 mb-0">
                    Phase #{phase?.id || "N/A"}
                  </h5>
                  {/* <div className="flex-shrink-0">
                    <Link to="/phases-invoice-details" className="btn btn-success btn-sm">
                      <i className="ri-download-2-fill align-middle me-1"></i>{" "}
                      Invoice
                    </Link>
                  </div> */}
                </div>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={6}>
                    <div className="d-flex mb-3">
                      <strong>Phase Name:</strong>
                      <p className="ms-3">{phase?.name || "N/A"}</p>
                    </div>
                    <div className="d-flex mb-3">
                      <strong>Project:</strong>
                      <p className="ms-3">{phase?.project || "N/A"}</p>
                    </div>
                    <div className="d-flex mb-3">
                      <strong>Starting Date:</strong>
                      <p className="ms-3">{phase?.starting_date ? formatDate(phase?.starting_date) : "N/A"}</p>
                    </div>
                    <div className="d-flex mb-3">
                      <strong>Estimated Finish Date:</strong>
                      <p className="ms-3">{phase?.estimated_finish_date ? formatDate(phase?.estimated_finish_date) : "N/A"}</p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="d-flex mb-3">
                      <strong>Actual Finish Date:</strong>
                      <p className="ms-3">{phase?.actual_finish_date ? formatDate(phase?.actual_finish_date) : "Not Finished"}</p>
                    </div>
                    <div className="d-flex mb-3">
                      <strong>Status:</strong>
                      <p className="ms-3">{phase?.active ? "Active" : "Inactive"}</p>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <div className="d-sm-flex align-items-center">
                  <h5 className="card-title flex-grow-1 mb-0">Phase Status</h5>
                </div>
              </CardHeader>
              <CardBody>
                <div className="profile-timeline">
                  <div className="accordion accordion-flush" id="accordionFlushExample">
                    <div className="accordion-item border-0" onClick={togglecol1}>
                      <div className="accordion-header" id="headingOne">
                        <Link
                          to="#"
                          className={classnames("accordion-button", "p-2", "shadow-none", { collapsed: !col1 })}
                        >
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 avatar-xs">
                              <div className="avatar-title bg-success rounded-circle">
                                <i className="ri-shopping-bag-line"></i>
                              </div>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h6 className="fs-15 mb-0 fw-semibold">
                                Phase Started -{" "}
                                <span className="fw-normal">{phase?.starting_date ? formatDate(phase?.starting_date) : "N/A"}</span>
                              </h6>
                            </div>
                          </div>
                        </Link>
                      </div>
                      <Collapse id="collapseOne" className="accordion-collapse" isOpen={col1}>
                        <div className="accordion-body ms-2 ps-5 pt-0">
                          <h6 className="mb-1">Phase has started.</h6>
                          <p className="text-muted">{phase?.starting_date}</p>
                        </div>
                      </Collapse>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          
        </Row>
      </Container>
    </div>
  );
};

export default PhaseDetail;
